// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".organizations-list .actions-buttons {\n  margin: 3px;\n}\n", "",{"version":3,"sources":["webpack://src/assets/styles/Organizations.less"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".organizations-list .actions-buttons {\n  margin: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
